import { GetURIByParts } from './Utils/StringUtils';
import store from '../store/Store';
import rootReducers from '../store/Reducers';
import Api from '../services/Api';
import { ApiResponse } from 'apisauce';

const reduxStore = store({}, rootReducers).getState();

enum ServiceEndPoints {
  GetAllTypes = 'GetAllTypes',
  NotificationTypes = 'NotificationTypes',
  ReportTypes = 'ReportTypes',
  NotificationStatusTypes = 'NotificationStatusTypes',
  TypesByName = 'GetTypesByName'
}

const serviceController = 'Lookup';

export function getNotificationTypes(addAllOption: boolean): any {
  const reduxStore: any = store({}, rootReducers).getState();
  let uri = GetURIByParts(
    reduxStore.Application.backendURL,
    serviceController,
    ServiceEndPoints.NotificationTypes
  );
  return nameValueGet(uri, addAllOption);
}

export function getAllTypes(addAllOption: boolean): any {
  const reduxStore: any = store({}, rootReducers).getState();
  let uri = GetURIByParts(
    reduxStore.Application.backendURL,
    serviceController,
    ServiceEndPoints.GetAllTypes
  );
  return nameValueGet(uri, addAllOption);
}

export function getReportTypes(addAllOption: boolean): any {
  const reduxStore: any = store({}, rootReducers).getState();
  let uri = GetURIByParts(
    reduxStore.Application.backendURL,
    serviceController,
    ServiceEndPoints.ReportTypes
  );
  return allTypesGet(uri, addAllOption);
}

export function getNotificationStatusTypes(addAllOption: boolean): any {
  const reduxStore: any = store({}, rootReducers).getState();
  let uri = GetURIByParts(
    reduxStore.Application.backendURL,
    serviceController,
    ServiceEndPoints.NotificationStatusTypes
  );
  return nameValueGet(uri, addAllOption);
}

function nameValueGet(uri, addAllOption) {
  return new Promise((resolve, reject) => {
    Api.get(uri).then((result: ApiResponse<any>) => {
      const formatted = [];
      if (addAllOption) {
        formatted.push({ name: 'All', value: '-1' });
      }
      result.data.map(item =>
        formatted.push({
          name: item.name,
          value: item.id
        })
      );
      resolve(formatted);
    });
  });
}

export function typesByName(name, addAllOption) {
  const reduxStore: any = store({}, rootReducers).getState();
  let uri = GetURIByParts(
    reduxStore.Application.backendURL,
    serviceController,
    ServiceEndPoints.TypesByName
  );

  return new Promise((resolve, reject) => {
    Api.get(uri + '?name=' + name).then((result: ApiResponse<any>) => {
      const formatted = [];
      if (addAllOption) {
        const allValue = Math.min(result.data.map(x => x.id)) - 1;
        formatted.push({ name: 'All', value: allValue.toString() });
      }
      result.data.map(item =>
        formatted.push({
          name: item.name,
          value: item.id
        })
      );
      resolve(formatted);
    });
  });
}

function allTypesGet(uri, addAllOption) {
  return new Promise((resolve, reject) => {
    Api.get(uri).then((result: ApiResponse<any>) => {
      const formatted = [];
      if (addAllOption) {
        formatted.push({ name: 'All', value: '-1' });
      }
      result.data.map(item =>
        formatted.push({
          name: item.name,
          value: item.id
        })
      );
      resolve(formatted);
    });
  });
}
